





























import Vue from 'vue';
import { getCoBuyers, showLoader, hideLoader, ordinals } from '@/util';
import { ModalType, Routes, ConfirmationModal, EventType } from '@/constants';
import { formatPhoneNumber } from './services/service';
import { User, Buyer, ConfirmationModalData } from '@/types';
import { mapGetters } from 'vuex';
import { removeCoBuyerFromHome } from '@/api';
import ChangePassword from './components/ChangePassword.vue';
import { signOut } from '@/core';
import { bus } from '@/main';

export default Vue.extend({
  name: 'MyAccount',
  components: {
    ChangePassword,
    RemoveCoBuyerModal: () => import('@/components/modals/ConfirmationModal.vue')
  },
  data () {
    return {
      isVisibleConfirmationModal: false,
      coBuyerRemovedModal: false,
      modalData: {} as ConfirmationModalData,
      ModalType,
      ordinals,
      ConfirmationModal
    }
  },
  computed: {
    ...mapGetters([
      'signedIn',
      'user',
      'isLoggedInAsAdmin',
      'hasUserData',
      'selectedJob',
      'isCoBuyer'
    ]),
    coBuyers (): User[] {
      return this.selectedJob ? getCoBuyers(this.selectedJob) : [] as User[];
    }
  },
  methods: {
    fullName (user: User | Buyer) {
      return `${user.firstName} ${user.lastName || ''}`.trim() || '';
    },
    phoneNumber (phone: string) {
      return phone ? formatPhoneNumber(phone) : '';
    },
    handleRemoveFromHomeClick () {
      if (!this.isLoggedInAsAdmin) {
        this.showConfirmationModal(ConfirmationModal.RemoveCoBuyer)
      } else {
        this.showViewVersionModal();
      }
    },
    async removeCoBuyer () {
      this.isVisibleConfirmationModal = false;
      showLoader();
      await removeCoBuyerFromHome(this.selectedJob);
      hideLoader();
      this.coBuyerRemovedModal = true;
      this.showConfirmationModal(ConfirmationModal.CoBuyerRemoved);
    },
    showConfirmationModal (modalData: ConfirmationModalData) {
      this.isVisibleConfirmationModal = true;
      this.modalData = modalData;
    },
    async closeConfirmationModal () {
      this.modalData = {} as ConfirmationModalData;
      this.isVisibleConfirmationModal = false;
      if (this.coBuyerRemovedModal) {
        this.coBuyerRemovedModal = false;
        await signOut();
        this.$router.push({ name: Routes.SIGNIN });
      }
    },
    showViewVersionModal () {
      bus.$emit(EventType.VIEW_VERSION);
    }
  }
});
